module.exports = __webpack_public_path__ + "static/media/BSW.d05c01ab.svg";